import gql from 'graphql-tag'

export const CREATE_UPDATE_BANNER = gql`
mutation upsertBanner($banner:[Banners_insert_input!]!, $updateColumns: [Banners_update_column!]!, 
       $attachments:[BannerImages_insert_input!]!, $updateColumnsAttachment: [BannerImages_update_column!]!, $deleteAttachmentIds: [uuid!]) {
  insert_Banners(objects: $banner, on_conflict: {constraint: Banners_pkey, update_columns: $updateColumns}){
    returning{id}
  }
  insert_BannerImages(objects: $attachments, on_conflict: {constraint: BannerImages_pkey, update_columns: $updateColumnsAttachment}){
    returning{id}
  }
  delete_BannerImages(where: {id: {_in: $deleteAttachmentIds}}){
   affected_rows
  }    
}`

export const UPDATE_BANNER_SEQUENCE = gql`
mutation upsertBanner($banner:[Banners_insert_input!]!, $updateColumns: [Banners_update_column!]!) {
  insert_Banners(objects: $banner, on_conflict: {constraint: Banners_pkey, update_columns: $updateColumns}){
    returning{id}
  }  
}`

export const UPDATE_EXPIRED_BANNERS = gql`
mutation updateExpiredBanners($ids: [uuid!], $obj:Banners_set_input) {
  update_Banners(where: {id: {_in: $ids}}, _set: $obj){
   affected_rows
  }
}`

export const DELETE_BANNER_BY_ID = gql`
mutation deleteBannerById($id:uuid!){
  delete_Banners(where:{id:{_eq:$id}}){
   returning{id}
  }
  delete_BannerImages(where:{bannerId:{_eq:$id}}){
   returning{id}
  }
  delete_BannerClicks(where:{bannerId:{_eq:$id}}){
   returning{id}
  }
}`

export const INSERT_WAREHOUSE_STOCK = gql`
mutation insertStockForExistingProductsWithNewBranch($warehouseStock:[WarehouseStock_insert_input!]!) {
  insert_WarehouseStock(objects: $warehouseStock){
    returning{
      id
    }
  }  
}`
